import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { KpisService } from './kpis.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  template: `
    <form [formGroup]="form" (ngSubmit)="submit(form)">
      <h1 mat-dialog-title *ngIf="data.id">Editar KPI</h1>
      <h1 mat-dialog-title *ngIf="!data.id">Nuevo KPI</h1>
      <mat-dialog-content>
        <mat-form-field>
          <input matInput formControlName="descripcion" placeholder="Descripción">
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-content>
        <mat-form-field>
          <input matInput formControlName="valor" placeholder="Valor">
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button type="submit" color="accent" [disabled]="form?.invalid">Guardar</button>
        <button mat-button type="button" (click)="onNoClick()">Cancelar</button>
      </mat-dialog-actions>
    </form>
  `
})
export class KpiDialogComponent implements OnInit {

  form: FormGroup;

  constructor(
    private kpisService: KpisService,
    private formBuilder: FormBuilder,
    private router: Router,
    private dialogRef: MatDialogRef<KpiDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
     };

     this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
           // trick the Router into believing it's last link wasn't previously loaded
           this.router.navigated = false;
           // if you need to scroll back to top, here is the right place
           window.scrollTo(0, 0);
        }
    });
   }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: this.data.id,
      descripcion: [this.data.descripcion, Validators.required],
      valor: [this.data.valor, Validators.required],
      clave: this.data.clave,
      activo_id: this.data.activo_id
    });

  }

  submit(form) {
    this.dialogRef.close();

    if (!form.value.id) {
      this.kpisService.addKpi(form.value).subscribe(
        data => {
          // console.log(data);
          if (data.success) {

            this.router.navigate(['/activos/editar', form.value.activo_id]);

          } else {
            console.warn(data.message);
          }
        },
        err => console.error(err)
      );

    }
    else {

      this.kpisService.updateKpi(form.value).subscribe(
        data => {

          if (data.success) {

            this.router.navigate(['/activos/editar', form.value.activo_id]);

          } else {
            console.warn(data.message);
          }
        },
        err => console.error(err)
      );
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/components/kpis-tabla/kpi-dialog.component.ts